/**
 * UI Functions for Perform OdontoVilas Website
 */

// Função para alternar entre mostrar mais ou menos texto
function toggleReadMore(button) {
    const parentDiv = button.parentNode;
    const description = parentDiv.querySelector('.card-description');
    
    if (description.classList.contains('line-clamp-expanded')) {
        // Recolher o texto
        description.classList.remove('line-clamp-expanded');
        button.textContent = 'Ler mais';
        
        // Rolagem suave para o início do card
        const card = parentDiv.closest('.hover-lift');
        if (card) {
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    } else {
        // Expandir o texto
        description.classList.add('line-clamp-expanded');
        button.textContent = 'Ler menos';
    }
}

// Verifica se o navegador suporta ResizeObserver
function supportsResizeObserver() {
    return typeof ResizeObserver === 'function';
}

// Função para ajustar os rodapés dos cartões
function adjustCardFooters() {
    const footers = document.querySelectorAll('.service-card-footer');
    
    // Primeiro resetar margens
    footers.forEach(footer => {
        footer.style.marginTop = '1.5rem'; // Valor inicial (mt-6)
    });
    
    // Obter a altura máxima do conteúdo
    const contents = document.querySelectorAll('.service-card-content');
    let maxHeight = 0;
    
    contents.forEach(content => {
        maxHeight = Math.max(maxHeight, content.offsetHeight);
    });
    
    // Aplicar margens para equalizar os rodapés
    contents.forEach((content, index) => {
        const diff = maxHeight - content.offsetHeight;
        if (diff > 0) {
            const footer = content.nextElementSibling;
            if (footer && footer.classList.contains('service-card-footer')) {
                footer.style.marginTop = `calc(1.5rem + ${diff}px)`;
            }
        }
    });
}

// Inicialização dos elementos da UI quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function() {
    // Verificar se o texto ultrapassa 4 linhas e só mostrar o botão se necessário
    const descriptions = document.querySelectorAll('.card-description');
    
    descriptions.forEach(desc => {
        const button = desc.parentNode.querySelector('.read-more-btn');
        
        // Calcula a altura do texto em 4 linhas
        const lineHeight = parseInt(window.getComputedStyle(desc).lineHeight);
        const maxHeight = lineHeight * 4;
        
        // Se o texto não exceder 4 linhas, esconde o botão
        if (desc.scrollHeight <= maxHeight) {
            if (button) button.style.display = 'none';
        }
    });

    // Configuração para alinhamento de cartões de serviços
    const serviceCards = document.querySelectorAll('.service-card');
    
    // Use ResizeObserver se suportado pelo navegador
    if (supportsResizeObserver()) {
        const resizeObserver = new ResizeObserver(entries => {
            adjustCardFooters();
        });
        
        serviceCards.forEach(card => {
            resizeObserver.observe(card);
        });
    } else {
        // Fallback para navegadores mais antigos
        adjustCardFooters();
        window.addEventListener('resize', adjustCardFooters);
    }
    
    // Ajustar quando o conteúdo expandir/retrair
    document.addEventListener('click', function(e) {
        if (e.target && e.target.classList.contains('read-more-btn')) {
            // Aguardar a transição de expansão terminar
            setTimeout(adjustCardFooters, 310);
        }
    });

    // Funcionalidade de "Ler mais" para avaliações
    const lerMaisBtn = document.getElementById('ler-mais-btn');
    const avaliacaoTooltip = document.getElementById('avaliacao-tooltip');
    const fecharTooltipBtn = document.getElementById('fechar-tooltip');
    const fecharTooltipX = document.getElementById('fechar-tooltip-x');
    
    const avaliacaoNome = document.getElementById('avaliacao-nome');
    const avaliacaoEstrelas = document.getElementById('avaliacao-estrelas');
    const avaliacaoTexto = document.getElementById('avaliacao-texto');
    const avaliacaoFoto = document.getElementById('avaliacao-foto');
    
    const tooltipNome = document.getElementById('tooltip-nome');
    const tooltipEstrelas = document.getElementById('tooltip-estrelas');
    const tooltipTexto = document.getElementById('tooltip-texto');
    const tooltipFoto = document.getElementById('tooltip-foto');
    
    // Função para abrir o tooltip
    function abrirTooltip() {
        if (avaliacaoTooltip) {
            // Copia os dados do card para o tooltip
            if (tooltipNome && avaliacaoNome) tooltipNome.textContent = avaliacaoNome.textContent;
            if (tooltipEstrelas && avaliacaoEstrelas) tooltipEstrelas.innerHTML = avaliacaoEstrelas.innerHTML;
            if (tooltipTexto && avaliacaoTexto) tooltipTexto.textContent = avaliacaoTexto.textContent;
            if (tooltipFoto && avaliacaoFoto) {
                tooltipFoto.src = avaliacaoFoto.src;
                tooltipFoto.alt = avaliacaoFoto.alt;
            }
            
            // Mostra o tooltip
            avaliacaoTooltip.classList.remove('hidden');
            setTimeout(() => {
                avaliacaoTooltip.classList.add('active');
            }, 10);
            
            // Bloqueia o scroll da página
            document.body.style.overflow = 'hidden';
        }
    }
    
    // Função para fechar o tooltip
    function fecharTooltip() {
        if (avaliacaoTooltip) {
            avaliacaoTooltip.classList.remove('active');
            setTimeout(() => {
                avaliacaoTooltip.classList.add('hidden');
                // Restaura o scroll da página
                document.body.style.overflow = '';
            }, 300);
        }
    }
    
    // Event listeners
    if (lerMaisBtn) {
        lerMaisBtn.addEventListener('click', abrirTooltip);
    }
    
    if (fecharTooltipBtn) {
        fecharTooltipBtn.addEventListener('click', fecharTooltip);
    }
    
    if (fecharTooltipX) {
        fecharTooltipX.addEventListener('click', fecharTooltip);
    }
    
    // Fechar o tooltip ao clicar fora dele
    if (avaliacaoTooltip) {
        avaliacaoTooltip.addEventListener('click', function(e) {
            if (e.target === avaliacaoTooltip || e.target.classList.contains('backdrop-blur-container')) {
                fecharTooltip();
            }
        });
    }
    
    // Fechar tooltip ao pressionar ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && avaliacaoTooltip && !avaliacaoTooltip.classList.contains('hidden')) {
            fecharTooltip();
        }
    });
});

// Função para detectar se é mobile
function isMobile() {
    return window.innerWidth <= 768;
}
